module.exports = __webpack_public_path__ + "images/RBL_logob832350d72ba18c304cda8a6ba712f40.svg";